module.exports = __webpack_public_path__ + "static/media/bg-mob.43fa834d.jpg";